import { observable, action, computed, makeObservable } from "mobx";

import { projectsDataStore } from "Stores/ProjectsStore";
import { ListStore } from "Stores/RESTStore/ListStore";
import { API_URL } from "General/APIEndpoints";
import { DataStore } from "Stores/RESTStore/DataStore";
import { EditStore } from "Stores/RESTStore/EditStore";
import { NewStore } from "Stores/RESTStore/NewStore";

class WorkflowDescriptionsList extends ListStore<API_WorkflowListEntry> {
  identifier = "workflowdefinition";

  url() {
    return API_URL.WORKFLOWS.getWorkflowDefinitions(projectsDataStore.projectId);
  }
}

class WorkflowDescriptionsListGUI extends WorkflowDescriptionsList {
  _selected: number = null;

  constructor() {
    super();

    makeObservable(this, {
      _selected: observable,
      setSelected: action.bound,
      selectedEntry: computed,
    });
  }

  setSelected(value: number) {
    this._selected = value;
  }

  get selectedEntry() {
    return this.find("workflowdefinition", this._selected as unknown as object);
  }
}

export const workflowDescriptionsList = new WorkflowDescriptionsListGUI();

interface WorkflowDescription {
  name: string;
  description: string;
  workflow: string;
}
class WorkflowDescriptionData extends DataStore<WorkflowDescription> {
  url(): string {
    throw new Error("Method not implemented.");
  }
}

export const workflowDescriptionData = new WorkflowDescriptionData();

class WorkflowDescriptionEdit extends EditStore<WorkflowDescription> {
  url(): string {
    throw new Error("Method not implemented.");
  }
}

export const workflowDescriptionEdit = new WorkflowDescriptionEdit(workflowDescriptionData);

class WorkflowDescriptionNew extends NewStore<WorkflowDescription> {
  defaultData: WorkflowDescription = {
    name: "",
    description: "",
    workflow: "",
  };

  url(): string {
    throw new Error("Method not implemented.");
  }
}

export const workflowDescriptionNew = new WorkflowDescriptionNew();
